import { Heart } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useCoachingEngagement } from '@/hooks/useCoachingEngagement';

export function CoachedByBadge() {
  const { activeCoaches, loading } = useCoachingEngagement();

  if (loading || activeCoaches.length === 0) return null;

  const coachName = activeCoaches[0].coach_display_name || 'a coach';

  return (
    <Badge variant="outline" className="gap-1 text-xs font-normal">
      <Heart className="h-3 w-3 text-primary" />
      Coached by {coachName}
    </Badge>
  );
}
